import React, { useState, useRef } from "react";
import DrawSpace25D from "./DrawSpace25D";
import { saveProject } from "../../database/mockProjectStore";

export default function TestMultiProject(props) {
  const [projectId, setProjectId] = useState("project-A");
  const lastDataRef = useRef(null);

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <button onClick={() => setProjectId("project-A")}>Project A</button>
        <button onClick={() => setProjectId("project-B")}>Project B</button>

        <button
          onClick={() => {
            if (lastDataRef.current) {
              saveProject(projectId, {
                id: projectId,
                sites: lastDataRef.current.sites ?? [],
                corridors: [],
              });
            }
          }}
        >
          Save current project
        </button>
      </div>

      <DrawSpace25D
        {...props}
        projectId={projectId}
        onChange={(data) => {
          lastDataRef.current = data;

          saveProject(projectId, {
            id: projectId,
            sites: data.sites ?? [],
            corridors: [],
          });

          props.onChange?.(data);
        }}
      />
    </div>
  );
}